module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./~/styled-jsx/style.js
// module id = 43
// module chunks = 168707334958949